///////////////////////////////////////////////////////////////////////////////
import Vue from 'vue'
import Router from 'vue-router'

import notFoundPage from '@/components/notFound'

import loginForm from '@/components/forms/Login'
import registrationForm from '@/components/forms/Registration'
import rememberForm from '@/components/forms/Remember'
import userCheckForm from '@/components/forms/UserCheck'
import emailCheckForm from '@/components/forms/EmailCheck'
import unsubscribeForm from '@/components/forms/Unsubscribe'

import List from '@/components/crud/List'
import View from '@/components/crud/View'
import vdsView from '@/components/crud/vdsView'
import sslView from '@/components/crud/sslView'
import domainView from '@/components/crud/domainView'
import Bonus from '@/components/crud/Bonus'
import Update from '@/components/crud/Update'
import Report from '@/components/crud/Report'
import ReportList from '@/components/crud/ReportList'
import Role from '@/components/crud/Role'
import ClientPay from '@/components/crud/ClientPay'
import TicketView from '@/components/crud/TicketView'
import QA from '@/components/crud/QA'
import Info from '@/components/crud/Info'
import Users from '@/components/crud/Users'
import error500 from '@/components/crud/error500'
import error503 from '@/components/crud/error503'
import filterUser from '@/components/filterUser'
import oldRoutes from '@/components/oldRoutes'
import operationView from '@/components/crud/operationView'
//import fileManager from '@/components/widgets/fileManager'

import store from '../store'
import { EventBus } from '@/bus.js'
///////////////////////////////////////////////////////////////////////////////
Vue.use(Router)
///////////////////////////////////////////////////////////////////////////////
const _router = new Router({
	//=========================================================================
	mode: 'history',
	//=========================================================================
	routes: [
		{ path: '/',
			redirect: to => {
				if (!store.state.is_auth) return '/login'

				// путь куда редиректнуть
				let redirectPath = null
				// ищем доступный путь в правах
				if (store.state.user_role && store.state.user_role.permissions && store.state.user_role.permissions.length)
				{
					// для начала проверим список VDS
					store.state.user_role.permissions.some(path => {
						if (path === 'service/list')
						{
							redirectPath = '/vds/list'
							return true
						}
					})

					// если нашли
					if (redirectPath) return redirectPath

					// ищем первый доступный
					store.state.user_role.permissions.some(path => {
						if (/\w+\/list$/i.test(path))
						{
							redirectPath = path
							return true
						}
					})
				}

				return redirectPath || '/qa/list'
			}
		},

		{ path: '/vds/:vdsGroupId/list', component: oldRoutes },
		{ path: '/vds/:vdsGroupId/list/:page', component: oldRoutes },

		{	path: '/logout',
			beforeEnter: (to, from, next) => {
				EventBus.$emit('w5-logout')
			}
		},

		//{ path: '/file-manager', component: fileManager },

		{ path: '/login', component: loginForm },
		{ path: '/register', component: registrationForm },
		{ path: '/forget', component: rememberForm },
		{ path: '/user/forget', component: rememberForm },
		{ path: '/user/check', component: userCheckForm },
		{ path: '/unsubscribe/:type/:code', component: unsubscribeForm },

		{ path: '/qa/list', component: QA },

		{ path: '/filter/user/:id', component: filterUser },

		{ path: '/options', component: Update },
		{ path: '/user/alerts', component: Update },
		{ path: '/user/alerts/:id', component: Update },

		{ path: '/email/create', component: Update },
		{ path: '/email/view/:id', component: View },
		{ path: '/email/check', component: emailCheckForm },

		{ path: '/vds/list', component: List },
		{ path: '/vds/list/:page', component: List },
		{ path: '/vds/create/:groupId/:planId', component: Update },
		{ path: '/vds/create', component: Update },
		{ path: '/vds/view/:id', component: vdsView },

		{ path: '/certificate/list', component: List },
		{ path: '/certificate/list/:page', component: List },
		{ path: '/certificate/create', component: Update },
		{ path: '/certificate/view/:id', component: sslView },

		{ path: '/dns/list', component: List },
		{ path: '/dns/list/:page', component: List },
		{ path: '/dns/create', component: Update },
		{ path: '/dns/view/:id', component: domainView },

		{ path: '/dns-records/create/:id', component: Update },
		{ path: '/dns-records/update/:id', component: Update },

		{ path: '/ipptrpool/list', component: List },
		{ path: '/ipptrpool/list/:page', component: List },
		{ path: '/ipptrpool/create/:id', component: Update },
		{ path: '/ipptrpool/update/:id', component: Update },
		{ path: '/ipptrpool/view/:id', component: View },

		{ path: '/iphistory/list', component: List },
		{ path: '/iphistory/list/:page', component: List },

		{ path: '/backups/list', component: List },
		{ path: '/backups/list/:page', component: List },
		{ path: '/backups/view/:id', component: View },

		{ path: '/disks/list', component: List },
		{ path: '/disks/list/:page', component: List },
		{ path: '/disks/view/:id', component: View },
		{ path: '/disks/create', component: Update },
		{ path: '/disks/update/:id', component: Update },

		{ path: '/sshkey/list', component: List },
		{ path: '/sshkey/list/:page', component: List },
		{ path: '/sshkey/view/:id', component: View },
		{ path: '/sshkey/update/:id', component: Update },
		{ path: '/sshkey/create', component: Update },

		{ path: '/iso/list', component: List },
		{ path: '/iso/list/:page', component: List },
		{ path: '/iso/view/:id', component: View },
		{ path: '/iso/create', component: Update },

		{ path: '/additional-services/list', component: List },
		{ path: '/additional-services/list/:page', component: List },
		{ path: '/additional-services/view/:id', component: View },

		{ path: '/service/view/:id', component: View },

		{ path: '/account/list', component: List },
		{ path: '/account/list/:page', component: List },
		{ path: '/account/view/:id', component: Info },
		{ path: '/account/update/:id', component: Update },

		{ path: '/dashboard/info', component: Info },
		{ path: '/users/list', component: Users },

		{ path: '/user/list', component: List },
		{ path: '/user/list/:page', component: List },
		{ path: '/user/view/:id', component: View },
		{ path: '/user/update/:id', component: Update },
		{ path: '/user/create', component: Update },

		{ path: '/notes/list', component: List },
		{ path: '/notes/list/:page', component: List },
		{ path: '/notes/view/:id', component: View },
		{ path: '/notes/create', component: Update },
		{ path: '/notes/create/:id', component: Update },

		{ path: '/operation/list', component: List },
		{ path: '/operation/list/:page', component: List },
		{ path: '/operation/view/:id', component: operationView },
		{ path: '/operation/update/:id', component: Update },
		{ path: '/operation/create', component: Update },
		{ path: '/operation/pay/:id', component: ClientPay },
		{ path: '/operation/select/:id', component: ClientPay },

		{ path: '/paymentsaved/list', component: List },
		{ path: '/paymentsaved/list/:page', component: List },
		{ path: '/paymentsaved/view/:id', component: View },

		{ path: '/request/list', component: List },
		{ path: '/request/list/:page', component: List },
		{ path: '/request/view/:id', component: View },
		{ path: '/request/update/:id', component: Update },

		{ path: '/partner/list', component: List },
		{ path: '/partner/list/:page', component: List },
		{ path: '/partner/view/:id', component: View },
		{ path: '/partner/create', component: Update },
		{ path: '/partner/update/:id', component: Update },

		{ path: '/partnerprogram/list', component: List },
		{ path: '/partnerprogram/list/:page', component: List },
		{ path: '/partnerprogram/view/:id', component: View },
		{ path: '/partnerprogram/update/:id', component: Update },
		{ path: '/partnerprogram/create', component: Update },

		{ path: '/partneractions/list', component: List },
		{ path: '/partneractions/list/:page', component: List },
		{ path: '/partneractions/view/:id', component: View },
		{ path: '/partneractions/update/:id', component: Update },

		{ path: '/bonus/list', component: List },
		{ path: '/bonus/list/:page', component: List },
		{ path: '/bonus/convert', component: Bonus },
		{ path: '/bonus/view/:id', component: View },
		{ path: '/bonus/update/:id', component: Update },
		{ path: '/bonus/create', component: Update },
		{ path: '/bonus/activate', component: Update },

		{ path: '/ticket/list', component: List },
		{ path: '/ticket/list/:page', component: List },
		{ path: '/ticket/view/:id', component: TicketView },
		{ path: '/ticket/view/:id/:page', component: TicketView },
		{ path: '/ticket/department/:depid', component: List },
		{ path: '/ticket/department/:depid/:page', component: List },
		{ path: '/ticket/create', component: Update },

		{ path: '/ticketmessage/view/:id', component: View },
		{ path: '/ticketmessage/update/:id', component: Update },

		{ path: '/logs/list', component: List },
		{ path: '/logs/list/:page', component: List },
		{ path: '/logs/view/:id', component: View },

		{ path: '/chart/list', component: ReportList },
		{ path: '/chart/view/:id', component: Report },

		{ path: '/template/list', component: List },
		{ path: '/template/list/:page', component: List },
		{ path: '/template/view/:id', component: View },
		{ path: '/template/update/:id', component: Update },
		{ path: '/template/create', component: Update },
		{ path: '/template/clone/:id', component: Update },

		{ path: '/ippool/list', component: List },
		{ path: '/ippool/list/:page', component: List },
		{ path: '/ippool/view/:id', component: View },
		{ path: '/ippool/update/:id', component: Update },
		{ path: '/ippool/create', component: Update },

		{ path: '/text/list', component: List },
		{ path: '/text/list/:page', component: List },
		{ path: '/text/view/:id', component: View },
		{ path: '/text/update/:id', component: Update },
		{ path: '/text/create', component: Update },

		{ path: '/admin/list', component: List },
		{ path: '/admin/list/:page', component: List },
		{ path: '/admin/view/:id', component: View },
		{ path: '/admin/update/:id', component: Update },
		{ path: '/admin/create', component: Update },

		{ path: '/role/list', component: List },
		{ path: '/role/list/:page', component: List },
		{ path: '/role/view/:id', component: View },
		{ path: '/role/update/:id', component: Role },
		{ path: '/role/create', component: Role },

		{ path: '/payment/list', component: List },
		{ path: '/payment/list/:page', component: List },
		{ path: '/payment/view/:id', component: View },
		{ path: '/payment/update/:id', component: Update },
		{ path: '/payment/create', component: Update },
		{ path: '/payment/clone/:id', component: Update },

		{ path: '/datacenter/list', component: List },
		{ path: '/datacenter/list/:page', component: List },
		{ path: '/datacenter/view/:id', component: View },
		{ path: '/datacenter/update/:id', component: Update },
		{ path: '/datacenter/create', component: Update },

		{ path: '/servergroup/list', component: List },
		{ path: '/servergroup/list/:page', component: List },
		{ path: '/servergroup/view/:id', component: View },
		{ path: '/servergroup/update/:id', component: Update },
		{ path: '/servergroup/create', component: Update },

		{ path: '/plangroup/list', component: List },
		{ path: '/plangroup/list/:page', component: List },
		{ path: '/plangroup/view/:id', component: View },
		{ path: '/plangroup/update/:id', component: Update },
		{ path: '/plangroup/create', component: Update },

		{ path: '/server/list', component: List },
		{ path: '/server/list/:page', component: List },
		{ path: '/server/view/:id', component: View },
		{ path: '/server/update/:id', component: Update },
		{ path: '/server/create', component: Update },
		{ path: '/server/clone/:id', component: Update },

		{ path: '/servicetype/list', component: List },
		{ path: '/servicetype/list/:page', component: List },
		{ path: '/servicetype/view/:id', component: View },
		{ path: '/servicetype/update/:id', component: Update },
		{ path: '/servicetype/create', component: Update },

		{ path: '/plan/list', component: List },
		{ path: '/plan/list/:page', component: List },
		{ path: '/plan/view/:id', component: View },
		{ path: '/plan/update/:id', component: Update },
		{ path: '/plan/create/:id', component: Update },
		{ path: '/plan/clone/:id', component: Update },

		{ path: '/planarchive/list', component: List },
		{ path: '/planarchive/list/:page', component: List },
		{ path: '/planarchive/view/:id', component: View },

		{ path: '/department/list', component: List },
		{ path: '/department/list/:page', component: List },
		{ path: '/department/view/:id', component: View },
		{ path: '/department/update/:id', component: Update },
		{ path: '/department/create', component: Update },

		{ path: '/ticketrule/list', component: List },
		{ path: '/ticketrule/list/:page', component: List },
		{ path: '/ticketrule/view/:id', component: View },
		{ path: '/ticketrule/update/:id', component: Update },
		{ path: '/ticketrule/create', component: Update },

		{ path: '/zone/list', component: List },
		{ path: '/zone/list/:page', component: List },
		{ path: '/zone/update/:id', component: Update },

		{ path: '/rack/list', component: List },
		{ path: '/rack/list/:page', component: List },
		{ path: '/rack/view/:id', component: View },
		{ path: '/rack/update/:id', component: Update },
		{ path: '/rack/create', component: Update },

		{ path: '/rackdevice/list', component: List },
		{ path: '/rackdevice/list/:page', component: List },
		{ path: '/rackdevice/links/:id', component: Update },
		{ path: '/rackdevice/clone/:id', component: Update },
		{ path: '/rackdevice/view/:id', component: View },
		{ path: '/rackdevice/update/:id', component: Update },
		{ path: '/rackdevice/create', component: Update },
		{ path: '/rackdevice/create/:id', component: Update },

		{ path: '/rackspare/list', component: List },
		{ path: '/rackspare/list/:page', component: List },
		{ path: '/rackspare/view/:id', component: View },
		{ path: '/rackspare/update/:id', component: Update },
		{ path: '/rackspare/create', component: Update },

		{ path: '/rackservice/list', component: List },
		{ path: '/rackservice/list/:page', component: List },
		{ path: '/rackservice/view/:id', component: View },
		{ path: '/rackservice/update/:id', component: Update },
		{ path: '/rackservice/create', component: Update },

		{ path: '/500', component: error500 },
		{ path: '/503', component: error503 },
		{ path: '/404', component: notFoundPage },
		{ path: '*', component: notFoundPage }
	]
	//=========================================================================

	/*,
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition)
			return savedPosition
		else
			return { x: 0, y: 0 }
	}*/
})

_router.beforeEach((to, from, next) => {
	let preset = ''

	if (to && from)
	{
		if (to.fullPath.indexOf('/ipptrpool/view') === 0 &&
			from.fullPath.indexOf('/logs/list') === 0 &&
			store.state.user_type === 'admin')
		{
			preset = 'admin_view_ipptrpool'
		}
	}

	store.commit('setMenuSelectingPreset', preset)

	next()
})

export default _router



// WEBPACK FOOTER //
// ./src/router/index.js